module.exports = __webpack_public_path__ + "static/pij_img_right-0ef32cd96e1ba9e1ea35c3a4202359f5.jpg";